import { AxiosInstance } from "axios";

export async function putProductClearCache(url: string, api: AxiosInstance) {
  const response = await api.put(url);
  return response.data;
}
